import * as R from 'ramda';

export const getStyle = path => R.view(R.lensPath(path));
